import localforage from 'localforage'
export class HistoryFeatureStore {
  constructor(params) {
    this.params = params || {}
    this.storeName = this.params.storeName
    this.store = this.createStore()
  }
  createStore () {
    return localforage.createInstance({name: this.storeName})
  }
  getItem (key) {
    return this.store.getItem(key)
  }
  setItem (key, val, cb) {
    this.store.setItem(key, val, (val) => {
      if (typeof cb === 'function') {
        val = cb(val)
      }
      return val
    })
  }
  removeItem (key, cb) {
    this.store.removeItem(key, (val) => {
      if (typeof cb === 'function') {
        val = cb(val)
      }
      return val
    })
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/history/store.js